export default "__VITE_ASSET__CmTlNQAG__";